/*eslint-disable*/
import React from 'react';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Dashboard, ExitToApp } from '@material-ui/icons';
// core components
import Button from 'components/CustomButtons/Button.jsx';
import withUser from '../HOC/HOCwithUser.jsx';
import headerLinksStyle from 'assets/jss/material-kit-react/components/headerLinksStyle.jsx';
import { CircularProgress, Select, MenuItem } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ROLE_PROVIDER, ROLE_CUSTOMER } from '../../utils/config/constants.js';
import {  Route, Switch, Redirect,Link } from 'react-router-dom';
import { store } from '../../store';
import NotificationList from '../../views/User/Notification';
import SideNav from '../../views/SideBar/SideNav';
import { cookies } from '../../utils/getToken.js';



const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
class MainPageLinks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            signupRedirect: false,
            signupRedirect2: false,
            dashboardRedirect: false,
	    logoutUser: false,
            language: 'en',
            becomeProvider: false
        };
    }
    
    handleChangeLanguage = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
        document.documentElement.lang = event.target.value;
        this.props.changeLanguageAction({ language: event.target.value });
    };

    renderSignin = () => {
        this.props.history.push('/user/signin', 
        {
            booking_data: null,
            taskData: null,
            loginPath: ''
        });
    };
    logoutCall = async () => {
        this.props.logoutAction(this.onDone);
    };
    onDone = (success, data) => {
        if (success) {
            this.setState({
                redirectMain: true
            });
        }
    };

    onLoginAsGuest = () => {
        cookies.set("x-auth-token", 'Guest', { path: "/" });
        this.props.history.push({ pathname: `/user/dashboard` });
    }
    render() {
        const { classes, userData } = this.props;
        const { dashboardRedirect, logoutUser } = this.state;
        if (this.state.signupRedirect) {
            this.props.history.push({
                pathname: `/Become` ,
                message:'Become a Service Pro with Us!',
                message2:'We want this to be a win, win. We only get paid if you get paid. We want to be the best so we only take the best.',
                state:{
                    becomeProvider: this.state.becomeProvider
                },

            });
            
        }
        if (this.state.signupRedirect2) {
            this.props.history.push({
                pathname: `/signup`,
                message:'Want a Trust Worthy Service That Will Make Your Life Easier?',
                message2:"You’re In the Right Place",
                state: {
                    becomeProvider: this.state.becomeProvider
                }
            });
        }
      
            if (this.props.userData.role == ROLE_PROVIDER) {
                if(this.props.userData.approved){
                    // this.props.history.push(`/user/dashboard`);
                    this.props.history.push(`/provider/dashboard`);
                }else{
                    this.props.history.push(`/user/profile/initial`);
                }
                
            } else if (this.props.userData.role == ROLE_CUSTOMER) {
                this.props.history.push(`/user/dashboard`);
            }
        

	if (logoutUser) {
		this.props.logoutAction(() => {
			this.props.history.push(`/`);
		});
	}

        if (this.props.isLoading) {
            return <CircularProgress />;
        }
        if (!userData.name) {
            return (
                <List className={classes.list + ' navigation-right'}>
                    <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff', fontWeight: "bold" }}
                    >
                        <Button id="login_btn"

                            target="_blank"
                            color="transparent"
                            className={classes.navLink + ''}
                            onClick={() => {
                                this.setState({ signupRedirect: true, signupRedirect2: false, becomeProvider: true });
                            }}
                            style={{ borderRadius: 5, paddingLeft: 25, paddingRight: 25, height: 35, fontWeight: "bold" }}
                        >
                        Become Service Pro
                        </Button>
                    </ListItem>
                    <ListItem 
                        className={classes.listItem}
                        style={{ color: '#ffffff' }}
                    >
                        <Button id="login_btn"
                            target="_blank"
                            color="transparent"
                            className={classes.navLink + ''}
                            onClick={() => {
                                this.setState({ signupRedirect2: true, signupRedirect: false, becomeProvider: false });
                            }}
                            style={{ border: "1px solid #ffffff", borderRadius: 5, paddingLeft: 20, paddingRight: 20, height: 35 }}
                        >
                            <FormattedMessage text="Want a Trust Worthy Service That Will Make Your Life Easier?"
                                id="Register"
                                defaultMessage="Sign Up"
                            />
                        </Button>
                    </ListItem>

                    <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff' }}
                    >
                        <Button id="login_btn"
                            target="_blank"
                            color="#1fbb54"
                            className={classes.navLink + ''}
                            onClick={this.renderSignin}
                            style={{
                                border: "1px solid #ffffff", background: "transparent",
                                borderRadius: 5, marginLeft: 20, paddingLeft: 20, paddingRight: 20, height: 35
                            }}
                        >
                            <FormattedMessage
                                id="header.Sign In"
                                defaultMessage="Sign In"
                            />
                        </Button>
                    </ListItem>
                    {/* <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff', fontWeight: "bold" }}
                    >
                        <Button id="login_btn"

                            target="_blank"
                            color="transparent"
                            className={classes.navLink + ''}
                            onClick={() => {
                                // this.setState({ signupRedirect: true, signupRedirect2: false, becomeProvider: true });
                                this.onLoginAsGuest()
                            }}
                            style={{ borderRadius: 5, paddingLeft: 25, paddingRight: 25, height: 35, fontWeight: "bold" }}
                        >
                        Login As Guest
                        </Button>
                    </ListItem> */}
                    {/* <ListItem className={classes.listItem}>
                        <Select
                            className="btn-login"
                            style={{ color: '#ffffff' }}
                            value={this.state.language}
                            onChange={this.handleChangeLanguage}
                            name="language"
                        >
                            <MenuItem value="en">English</MenuItem>
                            <MenuItem value="de">German</MenuItem>
                        </Select>
                    </ListItem> */}
                </List>
            );
        } else {
            return (
                <List className={classes.list + ' navigation-right'}>
                    <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff' }}
                    >
                        <Button
                            target="_blank"
                            color="transparent"
                            className={classes.navLink}
                            onClick={() =>
                                this.setState({ dashboardRedirect: true })
                            }
                        >
                            <Dashboard className={classes.icons} />{' '}
                            <FormattedMessage
                                id="header.dashboard"
                                defaultMessage="Dashboard"
                            />
                        </Button>
                    </ListItem>


                    

		    <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff' }}
                    >
                        <Button
                            target="_blank"
                            color="transparent"
                            className={classes.navLink}
                            onClick={this.logoutCall}
                        >
                            <ExitToApp className={classes.icons} />{' '}
                            <FormattedMessage
                                id="header.logout"
                                defaultMessage="Logout"
                            />
                        </Button>
                        
                    </ListItem>
          
                 <ListItem
                        className={classes.listItem}
                        style={{ color: '#ffffff' }}
                    >
                    <div className="d-lg-block d-sm-block noti_icon">
                       {/* <Button
                            target="_blank"
                            color="transparent" 
                           >
                        </Button> */}
                      
                      <SideNav {...sendProps(this.props)} 
                    isMainPage={true}
                    />  
                    </div>
                    </ListItem>
                  

                  
                    {/* <div
                        className={classes.content + ' tz-2 dashboard-main-div'}>
                            {store.getState().auth.userData.name != '' ? (
                            <Switch className="tz-2-com tz-2-main">
                                    <Route
                                    path={`/notification/list`}
                                    render={props => (
                                        <NotificationList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                            </Switch>
                        
                        ) : (
                            <Switch className="tz-2-com tz-2-main">
                                <Route component={NotAllowed} />
                            </Switch>
                        )}
                        </div> */}

                    {this.props.userData.role == ROLE_CUSTOMER && (
                        <ListItem
                            className={classes.listItem}
                            style={{ color: '#ffffff' }}
                        >
                            {/* <Badge
                                badgeContent={
                                    this.props.cartDetail.items
                                        ? this.props.cartDetail.items.length
                                        : 0
                                }
                            >
                                <Button
                                    target="_blank"
                                    color="transparent"
                                    className={
                                        (classes.navLink =
                                            '  btn-dash-cart mt-0')
                                    }
                                    onClick={
                                        () => this.redirectToCart()
                                        //this.setState({ cartRedirect: true })
                                    }
                                >
                                    <ShoppingCart />
                                </Button>
                            </Badge> */}
                        </ListItem>
                    )}
                    {/* <ListItem className={classes.listItem}>
                        <Select
                            className=""
                            style={{ color: '#ffffff' }}
                            value={this.props.currentLanguage}
                            onChange={this.handleChangeLanguage}
                            name="language"
                        >
                            <MenuItem value="en">English</MenuItem>
                            <MenuItem value="ar">Arabic</MenuItem>
                        </Select>
                    </ListItem> */}
                </List>
            );
        }
    }
}

const mapStateToProps = ({ auth, settings }) => {
    return {
        userData: auth.userData,
        currentLanguage: settings.currentLanguage
    };
};

const composedComponent = compose(
    withStyles(headerLinksStyle),
    connect(
        mapStateToProps,
        null
    )
);
export default composedComponent(withRouter(withUser(MainPageLinks)));



// WEBPACK FOOTER //
// ./src/components/Header/MainPageLinks.js